import axios from "axios";

export function callLogoutApi(refreshToken: string) {
  return axios({
    method: "POST",
    url: "/api/Security/logout",
    headers: {
      "Content-Type": "application/json",
    },
    data: { RefreshToken: refreshToken },
  });
}
